export default {
  name: 'ProgressBar',
  props: ['progressInfo', 'setWidth', 'setFont']
};